import { useSelector } from 'react-redux'

import { isAvailableFeatureSelector } from 'features/billing'

import { getFormValue } from '../utils'
import { getCustomDuration } from './get_custom_duration'

export const usePrepareValuesForPreview = () => {
  const isMultipleDurationsAvailable = useSelector((state) => isAvailableFeatureSelector(state, { featureKey: 'multiple_durations' }))

  return (eventType, formValues) => {
    const { eventDuration, customEventDuration, customEventDurationType } = formValues
    const { isMETChild, isMETParent } = eventType

    const syncMultipleDurations = (
      isMultipleDurationsAvailable
      && !isMETChild
      && !isMETParent)

    if (eventDuration === undefined) {
      return {
        duration: eventType.duration,
        duration_options: syncMultipleDurations ? eventType.duration_options : null
      }
    }

    return {
      duration: getFormValue(
        eventType.duration,
        (eventDuration === 'custom'
          ? getCustomDuration(customEventDuration, customEventDurationType)
          : parseInt(eventDuration, 10)),
        false),
      duration_options: syncMultipleDurations ? getFormValue(eventType.duration_options, formValues.durationOptions) : null
    }
  }
}
